import { Component, ViewEncapsulation } from '@angular/core';
import { Filter, FilterOperation, NotFilter } from 'src/app/core/jsonapi/filter';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom, } from 'rxjs';
import { TransactionsService } from '../_services/transactions.service';
import { Job } from '../../cases/_types/job';
import { BusinessService } from '../../business/_services/business.service';
import { WorkerBillableItem } from '../../workers/_types/worker-billable-item';
import { WorkerBillableItemsService } from '../../workers/_services/workers-billable-items.service';
import { Worker } from '../../workers/_types/worker';
import { WorkersService } from '../../workers/_services/workers.service';
import { JobsService } from '../../cases/_services/jobs.service';

@Component({
    selector: 'app-transactions-workers-business',
    templateUrl: './transactions-workers-business.component.html',
    styleUrls: ['./transactions-workers-business.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TransactionsWorkersBusinessComponent {

  public loading: boolean = false;
  public type!: string;

  private lastGridEvent: any;
  public filters: any = {
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  public jobsCaseServices: any[] = [];
  public billableItems: any[] = [];

  public workers: Worker[] = [];
  public business: any = [];
  public selectedLines: Job[] = [];
  public displayModal: boolean = false;
  public selectedDate: Date = new Date();


  public workersBusiness: any[] = [];

  public selectedWorkers: any[] = [];
  public selectedWorkerBusiness: { [key: string]: any[] } = {};


  constructor(
    private route: ActivatedRoute,
    public topbarService: TopbarService,
    private workersBillableItemsService: WorkerBillableItemsService,
    private workersService: WorkersService,
    private businessService: BusinessService,
    private messageService: MessageService,
    private transactionsService: TransactionsService,
    private confirmationService: ConfirmationService,
    private jobsService: JobsService,
  ) {


    this.allowWrite = true;
    this.allowDelete = true;
  }

  ngOnInit(): void {    
    this.route.paramMap.subscribe(() => {
      this.loadData();
    });

    this.loadWorkers();
    this.loadBusiness();

    this.selectedLines = [];

  }

  async loadData() {
    this.loading = true;
    let params: IParamsCollection = {

    }
    let filters: any = {
      isPayToWorker: new Filter(FilterOperation.equals, "isPayToWorker", "", false),
      /*isReview: new Filter(FilterOperation.equals, "isReview", "", true),
      isBillable: new Filter(FilterOperation.equals, "isBillable", "", true),
      */transactionId: new Filter(FilterOperation.equals, "transactionId", "", null, true)      
    };

    if(this.filters.businessId != null && this.filters.businessId != "null"){
      filters.businessId = new Filter(FilterOperation.equals, "businessId", "", this.filters.businessId);
    }

    if(this.filters.workerId != null && this.filters.workerId != "null"){
      filters.workerId = new Filter(FilterOperation.equals, "workerId", "", this.filters.workerId);
    }

    if(this.filters.dateFrom != null && this.filters.dateFrom != ""){
      filters.dateFrom = new Filter(FilterOperation.greaterOrEqual, "nextDate", "", this.filters.dateFrom.toISOString());
    }

    if(this.filters.dateTo != null && this.filters.dateTo != ""){
      filters.dateTo = new Filter(FilterOperation.greaterOrEqual, "nextDate", "", this.filters.dateTo.toISOString());
    }

    params.filter = FilterBuilder.fromObject(filters).build();
    params.include = ['business', 'worker', 'tax'];
    let workerBillableItemsResponse = await firstValueFrom(this.workersBillableItemsService.all(params));      
    
    let workerBillableItems = workerBillableItemsResponse.data.map((item: any) => {
      return { 
        id: item.id!,
        workerId: item.workerId,
        worker: item.worker,
        business: item.business,
        businessId: item.businessId,
        description: item.description,
        quantity: item.quantity,
        price: item.price,
        taxName: item.tax?.name,
        taxAmount: (item.quantity * item.price) * (item.tax?.percent / 100),
        type: "workerBillableItems"        
      }
    });    
    

    this.billableItems = [...workerBillableItems];

    // Agrupar los billableItems por trabajador
    this.workersBusiness = this.billableItems.reduce((acc, item) => {
      // Buscar si ya existe un trabajador en el acumulador
      const workerBussiness = acc.find((w:any) => w.workerId === item.workerId && w.businessId == item.businessId);
      
      if(workerBussiness){        
          // Si el trabajador ya existe, añadir el billableItem
          workerBussiness.billableItems.push({
            id: item.id!,
            description: item.description,
            quantity: item.quantity,
            price: item.price,
            taxName: item.taxName,
            taxAmount: item.taxAmount,
            type: item.type
            //hours: item.hours,
          });
      } else {
          // Si no existe, crear una nueva entrada para el trabajador          
          acc.push({
            id: item.workerId + "|" + item.businessId,
            type: item.type,
            workerId: item.workerId,            
            workerName: item.worker?.name,
            workerVat: item.worker?.vatNumber,
            businessId: item.businessId,
            businessName: item.business?.name,
            billableItems: [
              {
                id: item.id!,
                description: item.description,
                quantity: item.quantity,
                price: item.price,
                taxName: item.taxName,
                taxAmount: item.taxAmount,
                type: item.type
                //hours: item.hours,
              },
            ],
          });                
      }      

      return acc;
    }, [] as { id: string; workerId: string; workerName: string; workerVat: string; businessId: string; businessName: string; billableItems: { id: string; description: string; quantity: number; price: number; taxName: string; taxAmount: number; type: string; /*hours: number*/ }[] }[]);

    this.workersBusiness.forEach(workerBusiness => {
      if (workerBusiness.workerVat != null && workerBusiness.workerVat != "") {
        this.selectedWorkerBusiness[workerBusiness.id] = [];
        // Marca el checkbox del operador.
        this.selectedWorkers[workerBusiness.id] = true;

        // Selecciona todos los casos del operador.
        this.selectedWorkerBusiness[workerBusiness.id] = [...workerBusiness.billableItems];
      }

    });

  }

  toggleAllCases(id: string, isChecked: boolean) {
    if (!Array.isArray(this.selectedWorkerBusiness[id])) {
      this.selectedWorkerBusiness[id] = [];
    }

    if (isChecked) {
      // Selecciona todos los casos del operario
      this.selectedWorkerBusiness[id] = [...this.workersBusiness.find(item => item.id === id)?.billableItems || []];
    } else {
      // Deselecciona todos los casos del operario
      this.selectedWorkerBusiness[id] = [];
    }
  }


  updateHeaderCheckboxState(id: number): void {
    const allWorkerBusiness = this.workersBusiness.find(op => op.id === id)?.billableItems || [];

    this.selectedWorkers[id] =
      allWorkerBusiness.length > 0 && this.selectedWorkerBusiness[id].length === allWorkerBusiness.length;
  }


  async loadWorkers() {
    let allWorkers = new Worker();
    allWorkers.id = "null";
    allWorkers.name = "Todos";
    let response = await firstValueFrom(this.workersService.all());
    this.workers = response.data;
    this.workers.unshift(allWorkers);
  }

  async loadBusiness() {
    let allBusiness = new Worker();
    allBusiness.id = "null";
    allBusiness.name = "Todos";
    let response = await firstValueFrom(this.businessService.all());
    this.business = response.data;
    this.business.unshift(allBusiness);
  }


  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.loadData();
  }

  async save() {
    //Generamos factura por operario 
    let transactionSuccess = false;
    let failStr: string = "";
    for (const id in this.selectedWorkerBusiness) {            
      if(this.selectedWorkerBusiness[id].length > 0){
        let workerId = id.split("|")[0];
        let businessId = id.split("|")[1];                
        let data = {
          date: this.selectedDate.toISOString(),
          businessId: businessId,
          /*workerId: workerId,*/
          billableItemsIds: this.selectedWorkerBusiness[id].filter(item => item !== undefined && item.type == "workerBillableItems").map(n => n.id!),
          //jobsItemsIds: this.selectedWorkerBusiness[id].filter(item => item !== undefined && item.type == "job").map(n => n.id!),
        }          
        
        let result = await firstValueFrom(this.transactionsService.workerTransactionBusiness(workerId, data));

        this.displayModal = false;
        this.loadData()
        
      }      
      
    }

    if (transactionSuccess) {
      this.messageService.add({ closable: true, severity: 'success', summary: "Correcto", detail: "Factura generada correctamente." });
      this.displayModal = false;
      this.loadData();
    }

    if (failStr != "") {

      this.confirmationService.confirm({
        message: failStr,
        header: "Facturas no generadas",
        acceptLabel: "Aceptar",
        /*rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",*/
        icon: 'pi pi-exclamation-triangle',
        accept: () => {

        }
      });
    }
  }

  getSubtotalSelected(workerBusinessid: string | null): number {

    let allSelectedWorkerBusiness: any[] = [];

    for (let id in this.selectedWorkerBusiness) {
      if (this.selectedWorkerBusiness[id].length > 0 && (workerBusinessid == null || workerBusinessid == id)) {
        allSelectedWorkerBusiness = [...allSelectedWorkerBusiness, ...this.selectedWorkerBusiness[id]];
      }
    }

    return allSelectedWorkerBusiness.reduce((acc, line) => acc + (line.price * line.quantity), 0); 
  }

  getTaxAmountSelected(workerBusinessid: string | null): number {
    let allSelectedWorkerBusiness: any[] = [];

    for (let id in this.selectedWorkerBusiness) {
      if (this.selectedWorkerBusiness[id].length > 0 && (workerBusinessid == null || workerBusinessid == id)) {
        allSelectedWorkerBusiness = [...allSelectedWorkerBusiness, ...this.selectedWorkerBusiness[id]];
      }
    }

    return allSelectedWorkerBusiness.reduce((acc, line) => acc + (line.taxAmount), 0);
  }

  getTotalSelected(workerBusinessid: string | null): number {
    let allSelectedWorkerBusiness: any[] = [];

    for (let id in this.selectedWorkerBusiness) {
      if (this.selectedWorkerBusiness[id].length > 0 && (workerBusinessid == null || workerBusinessid == id)) {
        allSelectedWorkerBusiness = [...allSelectedWorkerBusiness, ...this.selectedWorkerBusiness[id]];
      }
    }

    return allSelectedWorkerBusiness.reduce((acc, line) => acc + ((line.quantity * line.price) + line.taxAmount), 0);
  }

  showModal() {
    if (this.hasSelectedWorkerBusiness()) {
      this.selectedDate = new Date();
      this.displayModal = true;
    } else {
      this.messageService.add({ closable: true, severity: 'error', detail: "Debe seleccionar al menos un concepto" });
    }
  }

  hideModal() {
    this.displayModal = false;
  }

  groupBy<T>(array: T[], key: keyof T): Record<string, T[]> {
    return array.reduce((result, currentValue) => {
      const groupKey = currentValue[key] as unknown as string;
      // Si el grupo para esta clave no existe, lo crea
      if (!result[groupKey]) {
        result[groupKey] = [];
      }
      // Agrega el elemento actual al grupo correspondiente
      result[groupKey].push(currentValue);
      return result;
    }, {} as Record<string, T[]>);
  }

  /*groupBy<T>(
    array: T[],
    key1: keyof T,
    key2: keyof T
  ): Record<string, T[]> {
    return array.reduce((result, currentValue) => {
      const groupKey1 = currentValue[key1] as unknown as string;
      const groupKey2 = currentValue[key2] as unknown as string;
  
      // Combina las dos claves para formar una clave única
      const combinedKey = `${groupKey1}|${groupKey2}`;
  
      // Si el grupo para esta clave combinada no existe, lo crea
      if (!result[combinedKey]) {
        result[combinedKey] = [];
      }
  
      // Agrega el elemento actual al grupo correspondiente
      result[combinedKey].push(currentValue);
      return result;
    }, {} as Record<string, T[]>);
  }  */


  hasSelectedWorkerBusiness(): boolean {
    for (let id in this.selectedWorkerBusiness) {
      if (this.selectedWorkerBusiness[id]?.length > 0) {
        return true; // Encontró al menos un case seleccionado
      }
    }
    return false; // No hay ningún case seleccionado
  }

  getTotalBillableItem(billableItem: any): number {

    return (billableItem.quantity * billableItem.price) + billableItem.taxAmount;
  }

}
